/* eslint-disable no-undef */
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { Mixpanel } from './Mixpanel';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.ENVIRONMENT,
    integrations: [new Sentry.BrowserTracing({}), new Sentry.Replay()],
    tracesSampleRate: process.env.ENVIRONMENT === 'local' ? 1.0 : 0.1,
    sampleRate: process.env.ENVIRONMENT === 'local' ? 1.0 : 0.1,
    release: process.env.SENTRY_RELEASE || "proctoring-admin@dev",
  });
  Mixpanel.init();
}

if (process.env.NODE_ENV === 'development' && process.env.MSW_ENABLED == 'true') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./msw/browser');
  worker.start().then(() => createRoot(document.getElementById('root')).render(<App />));
} else {
  createRoot(document.getElementById('root')).render(<App />);
}
